import React, { useState, useEffect, useCallback } from 'react';
import { Alert, Button, Form, Input, Modal, message } from 'antd';
import { createUseStyles } from 'react-jss'

import {
    EllipsisOutlined,
    CloseCircleFilled
} from '@ant-design/icons';

import { pushStateHistoryModal } from 'fennec-ui';

function SearchingModal(props) {
    const { auth, visible, hide, url, searchForm, selectForm, title, onDone, object } = props;
    const [loading, setLoading] = useState(false);
    const [searched, setSearched] = useState(undefined);
    const [warnSearch, setWarnSearch] = useState(false);

    const errorTitle = props.errorTitle || "Пользователь с указанными параметрами не найден";

    const [form] = Form.useForm();

    const SearchForm = searchForm;
    const SelectForm = selectForm;

    const closePopup = useCallback(() => {
        form.resetFields();
        hide();
        setSearched(undefined);
    }, [form]);

    const search = (obj) => {
        form.validateFields().then(values => {
            setLoading(true);
            auth.fetch(url, {
                method: 'POST',
                body: JSON.stringify(obj),
            }).then(res => {
                if (res.status && res.data) {
                    setWarnSearch(false);
                    setSearched(res.data);
                } else {
                    // message.error("Пользователь с указанными параметрами не найден");
                    setWarnSearch(true);
                    if (res.message) {
                        message.error("" + res.message);
                    }
                }
                setLoading(false);
            }).catch(err => {
                message.error("" + err);
                setLoading(false);
            })
        }).catch(errorInfo => {
            //    console.log(errorInfo)
        });
    };
    const handleSearch = (obj) => {
        search({ ...object, ...form.getFieldsValue() });
    };
    const handleBack = () => {
        setWarnSearch(false);
        setSearched(undefined);
    };
    const handleOk = () => {
        if (onDone) onDone(searched);
        setWarnSearch(false);
        closePopup();
    };
    const footer = () => {
        if (!searched) {
            return [
                <Button key="cancel" onClick={closePopup}>Отмена</Button>,
                <Button key="submit" type="primary" loading={loading} onClick={handleSearch}>Поиск</Button>,
            ];
        } else {
            return [
                <Button key="back" onClick={handleBack}>Назад</Button>,
                <Button key="submit" type="primary" loading={loading} onClick={handleOk}>Выбрать</Button>,
            ];
        }
    };

    return (
        <Modal
            open={visible}
            title={title}
            // onOk={handleOk}
            onCancel={closePopup}
            footer={footer()}
        >
            {warnSearch && <Alert message={<div>{errorTitle}</div>} banner style={{ marginBottom: "12px" }} />}
            {!searched && <SearchForm object={object} form={form} /*submit={handleSearch}*/ />}
            {!!searched && <SelectForm object={searched} />}
        </Modal>
    );
}
export default function InputObject(props) {
    const { auth, title, url, object, searchForm, selectForm, errorTitle, display, value, valueAsObject } = props;
    const classes = createUseStyles({
        input: {
            '&': {
                backgroundColor: "#ffffff"
            },
            '& .ant-input[disabled]': {
                flex: "auto",
                color: "rgba(0, 0, 0, 0.65)!important",
                backgroundColor: "#ffffff"
            }
        },
    })();

    const stack = [];
    const getStack = useCallback(() => {
        return stack;
    }, []);

    const [visible, setVisible] = useState(false);
    const [xvalue, setXValue] = useState(undefined);
    useEffect(() => {
        // setXValue(value);
    }, [value]);
    const show = () => {
        pushStateHistoryModal(setVisible, getStack);
        setVisible(true);
    };
    const hide = () => {
        // setVisible(false);
        window.history.back();
    };
    const onDone = (obj) => {
        if (obj) {
            setXValue(obj);
            if (props.onChange) {
                if (valueAsObject) {
                    props.onChange((props.modifyValue) ? props.modifyValue(obj) : obj);
                } else {
                    props.onChange(obj.ID);
                }
            }
        }
    };
    return (
        <Input.Group compact style={{ display: "flex" }}>
            <SearchingModal
                auth={auth}
                title={title}
                url={url}
                object={object}
                visible={visible}
                hide={hide}
                onDone={onDone}
                searchForm={searchForm}
                selectForm={selectForm}
                errorTitle={errorTitle}
            />
            <Input id={props.id} value={(props.value && valueAsObject) ? props.value.ID : props.value} hidden={true} />
            <Input style={{ borderStartStartRadius: "6px", borderEndStartRadius: "6px" }} suffix={
                <div style={{ fontSize: "12px" }}>
                    {xvalue && <CloseCircleFilled style={{ cursor: 'pointer', color: 'rgba(0,0,0,.45)' }}
                        onClick={() => {
                            setXValue(undefined)
                            if (props.onChange) {
                                props.onChange(undefined);
                            }
                        }} />}
                </div>
            } value={(xvalue) ? (display) ? display(xvalue) : xvalue.lastname + " " + xvalue.firstname + ((xvalue.patronymic) ? " " + xvalue.patronymic : "") : ""} disabled allowClear className={classes.input} />
            <Button style={{ padding: "4px 8px" }} onClick={show}>
                <EllipsisOutlined style={{ paddingTop: "7px", fontSize: '16px' }} />
            </Button>
        </Input.Group>
    );
}